import React, { useState, useEffect } from "react";

const Thankyou = ({ change }) => {
    const urlSearchString = window.location.search;

    const params = new URLSearchParams(urlSearchString);
   
    var strPaymentStatus = params.get('redirect_status');
    var payment_intent =  params.get('payment_intent');
    var payment_intent_client_secret =  params.get('payment_intent_client_secret');

    if(strPaymentStatus == "succeeded")
    {
        //Add payment to database and take username and basket into database to get orders list
        var strEmail = localStorage.getItem('MuckS_LoginState');
        var salesData = localStorage.getItem('MuckS_Basket');
        try {
            fetch('https://mucksucker.com:3001/api/addsalesdata', {
              method: 'post',
              headers: {'Content-Type':'application/json'},
              body: JSON.stringify({
                email: strEmail,
                salesData: salesData,
                paymentIntent : payment_intent

              })
             })
             .then(response => response)
             .then((response) => {
                 console.log(response)
             })
             .catch(err => console.log(err));;
      
          } catch(err) 
          {
            alert(err);
          }

        localStorage.setItem('MuckS_Basket', []);
        change([]);

        return (
            <div className="center">
              <h1>Thanks</h1>
              <div className="container">
      
              </div>
      
            </div>
          )
    }
    else
    {
        return (
            <div className="center">
              <h1>Payment Not Successful</h1>
              <div className="container">
      
              </div>
      
            </div>
          )
    }

  };
  
  export default Thankyou;